var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1113(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 79,
    viewBox: "0 0 94 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_240_6106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1485 16.91C99.1485 7.71713 86.8381 0.786133 70.5118 0.786133C54.1855 0.786133 41.875 7.71713 41.875 16.91C41.875 16.9916 41.8929 17.0688 41.8951 17.1494H41.875V29.4218H50.0566V28.4083C55.1766 31.2955 62.3402 33.0316 70.5118 33.0316C78.0502 33.0316 84.7105 31.5405 89.7197 29.0448C90.496 29.848 90.9669 30.6467 90.9669 31.3469C90.9669 34.507 82.8088 39.2869 70.5118 39.2869H62.3324V47.4685H70.5118C78.0513 47.4685 84.7138 45.9774 89.723 43.4806C90.5005 44.2827 90.9658 45.0814 90.9658 45.785C90.9658 48.9474 82.8077 53.7272 70.5107 53.7272L67.6145 53.7407C65.8348 53.7563 64.111 53.7731 62.4308 53.7284L62.2306 61.9066C63.13 61.929 64.0405 61.9368 64.969 61.9368C65.8561 61.9368 66.7588 61.9312 67.6761 61.9234L70.5107 61.91C78.0546 61.91 84.7194 60.4166 89.7297 57.9176C90.5094 58.7264 90.9647 59.5295 90.9647 60.2242C90.9647 63.3866 82.8066 68.1664 70.5095 68.1664H62.3302V76.348H70.5095C78.0535 76.348 84.7172 74.8547 89.7286 72.3557C90.5094 73.1633 90.9647 73.9665 90.9647 74.6623C90.9647 77.8246 82.8066 82.6045 70.5095 82.6045H62.3302V90.7861H70.5095C86.8358 90.7861 99.1463 83.8551 99.1463 74.6623C99.1463 74.5862 99.1362 74.5001 99.134 74.4229H99.1463V17.1494H99.1262C99.1295 17.0688 99.1485 16.9905 99.1485 16.91ZM50.0566 16.91C50.0566 13.7476 58.2147 8.96775 70.5118 8.96775C82.8088 8.96775 90.9669 13.7476 90.9669 16.91C90.9669 20.0701 82.8088 24.85 70.5118 24.85C58.2147 24.85 50.0566 20.0701 50.0566 16.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6016 29.4219C13.2753 29.4219 0.964844 36.3529 0.964844 45.5457C0.964844 45.6274 0.982742 45.7046 0.984979 45.7851H0.964844V74.4219C0.964844 83.6147 13.2753 90.5457 29.6016 90.5457C45.9279 90.5457 58.2384 83.6147 58.2384 74.4219V45.7862H58.2182C58.2205 45.7057 58.2384 45.6274 58.2384 45.5469C58.2384 36.354 45.9279 29.4219 29.6016 29.4219ZM9.14646 59.9849C9.14646 59.278 9.60845 58.4804 10.3859 57.6783C15.3962 60.1762 22.0599 61.6685 29.6016 61.6685C37.14 61.6685 43.8003 60.1773 48.8095 57.6817C49.5858 58.4849 50.0568 59.2836 50.0568 59.9838C50.0568 63.1439 41.8986 67.9238 29.6016 67.9238C17.3046 67.9238 9.14646 63.145 9.14646 59.9849ZM29.6016 37.6046C41.8986 37.6046 50.0568 42.3845 50.0568 45.5469C50.0568 48.707 41.8986 53.4868 29.6016 53.4868C17.3046 53.4868 9.14646 48.707 9.14646 45.5469C9.14646 42.3845 17.3046 37.6046 29.6016 37.6046ZM29.6016 82.3652C17.3046 82.3652 9.14646 77.5854 9.14646 74.423C9.14646 73.7194 9.61292 72.9207 10.3892 72.1186C15.3996 74.6154 22.061 76.1077 29.6016 76.1077C37.1411 76.1077 43.8037 74.6165 48.8129 72.1198C49.5903 72.9218 50.0557 73.7205 50.0557 74.4241C50.0568 77.5854 41.8986 82.3652 29.6016 82.3652Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_240_6106",
    x: 0.964844,
    y: 0.786133,
    width: 98.1836,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_240_6106"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1113);
export default __webpack_public_path__ + "static/media/Group 1113.6e03d38d3e4f9781ab205f421746bedb.svg";
export { ForwardRef as ReactComponent };